import React from 'react';
import { Link } from 'react-router-dom';

interface FilterHeaderProps {
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
    selectedSort: string;
    setSelectedSort: (sort: string) => void;
}

const statusOptions = [
    { label: 'All', value: '' },
    { label: 'Scheduled', value: 'scheduled' },
    { label: 'In Progress', value: 'in_progress' },
    { label: 'Completed', value: 'completed' },
    { label: 'Cancelled', value: 'cancelled' },
];

const sortOptions = [
    'Recently Added',
    'Ascending',
    'Descending',
    'Last Month',
    'Last 7 Days',
];

const AssetMaintenanceFilterHeader: React.FC<FilterHeaderProps> = ({
    selectedStatus,
    setSelectedStatus,
    selectedSort,
    setSelectedSort
}) => {
    const getStatusLabel = (value: string) => {
        const match = statusOptions.find(option => option.value === value);
        return match ? match.label : 'Select Status';
    };

    return (
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h5>Asset Maintenance List</h5>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {getStatusLabel(selectedStatus)}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {statusOptions.map(({ label, value }) => (
                            <li key={value}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedStatus(value)}
                                    className="dropdown-item rounded-1"
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="dropdown">
                    <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                    >
                        {selectedSort ? `Sort By : ${selectedSort}` : "Sort By : Last 7 Days"}
                    </Link>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                        {sortOptions.map((sort) => (
                            <li key={sort}>
                                <Link
                                    to="#"
                                    onClick={() => setSelectedSort(sort)}
                                    className="dropdown-item rounded-1"
                                >
                                    {sort}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AssetMaintenanceFilterHeader;
